import type { IContextMutationResult } from '@modules/core/services/query/types';
import type { IDownloadListReportPayload } from '@modules/download-report/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextMutation } from '@modules/core/services/query';
import {
  WEBHOOKS_HISTORY_DOWNLOAD_LIST_API_URL,
  WEBHOOKS_HISTORY_DOWNLOAD_LIST_MUTATION_KEY,
  WEBHOOKS_HISTORY_PERMISSIONS,
} from '@modules/webhooks-history/constants';

export default function useDownloadWebhooksHistoryReportMutation(): IContextMutationResult<
  void,
  Error,
  IDownloadListReportPayload
> {
  const { fetchPost } = useRestClient();

  return useContextMutation<void, Error, IDownloadListReportPayload>({
    mutationKey: [WEBHOOKS_HISTORY_DOWNLOAD_LIST_MUTATION_KEY],
    mutationFn: (payload) => fetchPost<void>(
      WEBHOOKS_HISTORY_DOWNLOAD_LIST_API_URL,
      payload,
      { permission: WEBHOOKS_HISTORY_PERMISSIONS.DOWNLOAD },
    ),
  });
}
